import { render } from "./VehicleOptionsTabComponent.vue?vue&type=template&id=9d16e22c&scoped=true"
import script from "./VehicleOptionsTabComponent.vue?vue&type=script&lang=js"
export * from "./VehicleOptionsTabComponent.vue?vue&type=script&lang=js"

import "./VehicleOptionsTabComponent.vue?vue&type=style&index=0&id=9d16e22c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d16e22c"]])

export default __exports__